import React from 'react';
import styled from 'styled-components';
import theme from 'styles/theme';
import { Text } from 'components/pages/market/home/MarketItem';

function SimpleTextModalContents({ text, textStyle, onClose }) {
   return (
      <SimpleTextModalWrap>
         <Text style={textStyle}>{text}</Text>
         <OkButton onClick={onClose}>{'확인'}</OkButton>
      </SimpleTextModalWrap>
   );
}

export default SimpleTextModalContents;

const SimpleTextModalWrap = styled.div`
   padding: 32px 40px 28px 40px;

   ${Text} {
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 16px;
   }
`;

const OkButton = styled.button`
   background-color: ${theme.color.orange};
   border-radius: 8px;
   padding: 10px;
   color: ${theme.color.white};
   width: 200px;
   border: none;
   cursor: pointer;
   user-select: none;
`;
